import React, { useState } from "react";
import { Table, Button, FormControl } from "react-bootstrap"; // import Button and FormControl

function DataTable({ tableData }) {
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedTableData = React.useMemo(() => {
    let sortableItems = [...tableData];

    // Filter based on search term
    if (searchTerm) {
      sortableItems = sortableItems.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    // Sort the filtered items
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [tableData, sortConfig, searchTerm]);

  return (
    <div>
      <h2>Show data Imported</h2>
      <div className="search-container">
        <FormControl
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {tableData.length > 0 &&
              Object.keys(tableData[0]).map((key) => (
                <th
                  key={key}
                  onClick={() => requestSort(key)}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "10px",
                    textAlign: "left",
                    cursor: "pointer",
                  }}
                >
                  {key}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {sortedTableData.map((row, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#e0e0e0",
              }}
            >
              {Object.entries(row).map(([key, value], i) => (
                <td
                  key={i}
                  style={{
                    backgroundColor:
                      (key === "Status" && value === "Price Mismatch") ||
                      (key === "StatusQTY" && value === "QTY NOT MATCH")
                        ? // key === "StatusQTY" && value === "NOT MATCH"
                          "red"
                        : (key === "Status" && value === "Not Compare") ||
                          (key === "StatusQTY" && value === "NO INVOICE")
                        ? "blue"
                        : "transparent",
                    color:
                      (key === "Status" && value === "Price Mismatch") ||
                      (key === "Status" && value === "Not Compare") ||
                      (key === "StatusQTY" && value === "NO INVOICE")
                        ? "white"
                        : "black",
                    padding: "8px",
                  }}
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
